// /client/src/components/KeepGoing.js
import React from 'react';
import NavigationPdfs from './NavigationPdfs';
import FooterPdfs from './FooterPdfs';

const KeepGoing = () => {
  return (
    <>
      <div className="fullHeight is-flex is-flex-direction-column is-align-items-center is-justify-content-space-between">
        <div className='fullWidth'>
            <NavigationPdfs />
            <div className="pt-2 columns is-centered">
                <div className="column is-6-tablet is-5-desktop is-5-widescreen">
                    <div className="px-4 py-5">
                        <h1 className="h1 colorBlack is-bold">Keep it Going</h1>
                        <h2 className='h2 is-bold'>Introduction</h2>
                        <p className="pb-4 colorBlack">
                            If you've worked through the Next Move Method—for a few days, weeks, or months—hopefully you've gotten a sense of what it means to “Do Life Different. Now.” Working with a pod to check in, clarify, and take incremental steps as you navigate toward goals that matter to you, can make a huge difference in your life.
                        </p>
                        <p className="pb-4 colorBlack">
                            Click the download button below to view the optional reading. 
                        </p>
                        <div className="py-5 field">
                            <a 
                                href="/pdfs/next-move-keep-it-going.pdf"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="button"
                                download
                            >
                                Download PDF
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
       <FooterPdfs />
      </div>
    </>
  );
};

export default KeepGoing;